module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Picnic-At-Hanging-Rock-S1.184a0ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Picnic-At-Hanging-Rock-S1.jpg
// module id = Ay4q
// module chunks = 0